import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const DeliveryAddressesFragmentDoc = gql`
  fragment DeliveryAddresses on DeliveryAddress {
    id
    city
    country
    line1
    line2
    locationName
    postalCode
    stateProvince
    createdAt
    updatedAt
  }
` as unknown as DocumentNode<Types.DeliveryAddressesFragment, unknown>
